import React from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import { Box, Typography } from "@mui/material";
import {
  CancelButton,
  DeleteButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCycle,
  getAllEvaluationcycle,
} from "../../../../../redux/features/appraisalSlice";
import useHandleApiResponse from "../../../../../Hooks/useHandleApiResponse";

const DeleteCycle = ({ open, setOpen, id }) => {
  const handleApiResponse = useHandleApiResponse();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.appraisal);

  const handleDelete = () => {
    dispatch(deleteCycle(id)).then((res) => {
      handleApiResponse(res, {
        onSuccess: () => {
          setOpen(false);
          dispatch(getAllEvaluationcycle());
        },
        onFailed: () => {
          console.log("Something went wrong");
        },
      });
    });
  };
  return (
    <GlobalDialog
      open={open}
      setOpen={setOpen}
      title={"Delete Cycle"}
      closeButton={true}
      fullWidth
      maxWidth={"xs"}
      content={
        <Box>
          <Typography>
            Are you sure ? you want to delete this cycle...!
          </Typography>
        </Box>
      }
      actionButton={
        <>
          <CancelButton size={"small"} action={() => setOpen(false)}>
            Cancel
          </CancelButton>
          <DeleteButton disabled={loading} action={handleDelete} size={"small"}>
            {loading ? "Please wait..." : "Delete"}
          </DeleteButton>
        </>
      }
    />
  );
};

export default DeleteCycle;
